<template>
  <Switch v-model="enabled" :disabled="disabled" :class="[enabled ? 'bg-slate-700' : 'bg-gray-200', disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer', 'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500']">
    <span aria-hidden="true" :class="[enabled ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200']" />
  </Switch>
</template>

<script>
import { Switch } from '@headlessui/vue'

export default {
  components: {
    Switch,
  },
  props: {
    // Suporta tanto v-model (modelValue) quanto prop value (legado)
    modelValue: {
      type: Boolean,
      required: false,
    },
    value: {
      type: Boolean,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {    
    return {
      enabled: false,
      isInitialized: false,
    }
  },

  watch: {
    modelValue(newValue) {
      if (newValue !== undefined) this.enabled = newValue;
    },
    value(newValue) {
      // Só usa "value" se não houver modelValue
      if (this.modelValue === undefined) this.enabled = newValue;
    },
    enabled(newValue) {
      if (!this.isInitialized) return;
      this.$emit('update:modelValue', newValue);
    },
  },

  created() {
    if (this.modelValue !== undefined) {
      this.enabled = this.modelValue;
    } else if (this.value !== undefined) {
      this.enabled = this.value;
    } else {
      this.enabled = false;
    }
    this.isInitialized = true;
  },

}
</script>